import React, { PureComponent } from 'react';
import PT from 'prop-types';
import { ReactFormGroupWrapper } from './reactformgroupwrapper';

export class ReactFormMultipleItems extends PureComponent {
    constructor(props) {
        super(props);
        this.handleAddItem = this.handleAddItem.bind(this);
        this.handleDeleteItem = this.handleDeleteItem.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleHideMode = this.handleHideMode.bind(this);
        this.handleEditMode = this.handleEditMode.bind(this);
        this.handleEditItem = this.handleEditItem.bind(this);
        this.handleExitEditMode = this.handleExitEditMode.bind(this);
        this.state = {
            field: '',
            hideMode: true, 
            editMode: false,
            currentEditedItemIndex: ''
        };
    }

    handleInputChange(e) {
        this.setState({ field: e.target.value });
    }
    
    handleAddItem() {
        if(!(this.props.field.isRequired && this.state.field === "")) {
            let items = [...this.props.value];
            if (this.props.value) {
                items.push(this.state.field);
            }
            else {
                items = [this.state.field];
            }
    
            if(this.props.onChange)
                this.props.onChange(items);
       
            
            this.setState({field: ''});
        }

        else {
            //console.log("Champ requis");
        }
        
    }

    handleEditItem() {
        let items = [...this.props.value];
        items[this.state.currentEditedItemIndex] = this.state.field;
        if(this.props.onChange)
            this.props.onChange(items);
        this.setState({field: '', editMode: false});
    }

    handleDeleteItem(index) {
        let items = [...this.props.value];
        items.splice(index, 1);
            if(this.props.onChange)
                this.props.onChange(items);       
    }

    handleHideMode() {
        this.setState(prevState => ({
            hideMode: !prevState.hideMode
        }));
    }

    handleEditMode(index) {
        let selectedItem = this.props.value[index];     
        this.setState({field: selectedItem, hideMode: false, editMode: true, currentEditedItemIndex: index});
    }

    handleExitEditMode() {
        this.setState({field: '', editMode: false});
    }

    render() {
        const MultipleItemsView = this.props.viewProvider.getMultipleItemsView();
        const display = this.state.hideMode ? { display: 'none' } : {};
        const editModeButtonText = !this.state.editMode ? "Ajouter" : "Sauvegarder les modifications";
        const actionOnCancel = !this.state.editMode ? this.handleHideMode : this.handleExitEditMode;
        const actionOnSubmit = !this.state.editMode ? this.handleAddItem : this.handleEditItem;

        let hideModeButtonText;
        if (this.state.hideMode)
            hideModeButtonText = "Ajouter";
        else if (this.state.editMode)
            hideModeButtonText = "Annuler les modifications";
        else 
            hideModeButtonText = "Fermer les champs";
        
        

        return (
            <ReactFormGroupWrapper {...this.props}>
                    <MultipleItemsView
                        value={this.props.value}
                        fieldValue={this.state.field}
                        onInputChange={this.handleInputChange}
                        onEdit={this.handleEditMode}
                        onDelete={this.handleDeleteItem}
                        field={this.props.field}
                        editModeButtonText={editModeButtonText}
                        hideModeButtonText={hideModeButtonText}
                        actionOnSubmit={actionOnSubmit}
                        display={display}
                        editMode={this.state.editMode}
                        handleHideMode={this.handleHideMode}
                        hideMode={this.state.hideMode}
                        actionOnCancel={actionOnCancel}
                        isMultilingual={this.props.isMultilingual}
                        lang={this.props.lang}
                        isInvalid={this.props.showValidationErrors}
                    />                                                                                                                                    
            </ReactFormGroupWrapper>
        );
    }
}

ReactFormMultipleItems.propTypes = {
    name: PT.string,
    value: PT.any,
    onChange: PT.func,
    validationErrors: PT.array,
    showValidationErrors: PT.bool,
    viewProvider: PT.object,
    field: PT.shape(),
    isMultilingual: PT.bool,
    lang: PT.string
};

ReactFormMultipleItems.defaultProps = {
    value: "" 
};
